// extracted by mini-css-extract-plugin
module.exports = {"Button":"Shortcuts_Button__29mQh","MenuItem":"Shortcuts_MenuItem__1WdFv","PresetName":"Shortcuts_PresetName__3Ra9o","EditPresetIcon":"Shortcuts_EditPresetIcon__3Ywgv"};